var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sa"},[_c('div',{staticClass:"sa-success",style:({ 'width' : _vm.width, 'height' : _vm.height })},[_c('div',{staticClass:"sa-success-tip"}),_c('div',{staticClass:"sa-success-long"}),_c('div',{staticClass:"sa-success-placeholder"}),_c('div',{staticClass:"sa-success-fix"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }